import embedBots from "./embedBots.json";

export const EMBED_TARGET = {
  bucket: "omni-embed-hosting",
  region: "us-west-2",
  domain: "embed.omnisciahealth.coach",
  distributionId: "E5SAY1UANPUMG",
  cacheControl: "public, max-age=300",
  backupPrefix: "backups",
};

export const EMBED_DEFAULTS = embedBots.defaults;

export const LOADER_TEMPLATE_TOKEN = "__OMNI_EMBED_CONFIG__";

export const LOADER_TEMPLATE = `(function () {
  "use strict";

  var CONFIG = __OMNI_EMBED_CONFIG__;

  var FLAG = "__omniEmbedLoaded_" + CONFIG.key;
  if (window[FLAG]) {
    return;
  }
  window[FLAG] = true;

  var RUNTIME_SRC =
    "https://cdn.botpress.cloud/webchat/" + CONFIG.botpressVersion + "/inject.js";

  function installLinkClickCapture() {
    var webhook = CONFIG.clickWebhook;
    if (!webhook || /YOUR_WEBHOOK_ID|REPLACE_/.test(webhook)) {
      return;
    }

    var originalOpen = window.open;
    window.open = function (url, target, features) {
      if (url && target === "_blank") {
        try {
          fetch(webhook, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              botId: CONFIG.botId,
              url: url,
              timestamp: new Date().toISOString(),
            }),
          }).catch(function () {});
        } catch (error) {}
      }
      return originalOpen.call(this, url, target, features);
    };
  }

  function initBot() {
    if (!window.botpress || typeof window.botpress.init !== "function") {
      if (window.console) {
        console.error(
          "[omni-embed] Botpress runtime loaded but window.botpress.init is unavailable.",
        );
      }
      return;
    }

    window.botpress.init({
      botId: CONFIG.botId,
      clientId: CONFIG.clientId,
      configuration: CONFIG.configuration || {},
    });
  }

  function loadRuntime() {
    var script = document.createElement("script");
    script.src = RUNTIME_SRC;
    script.async = true;
    script.onload = initBot;
    script.onerror = function () {
      if (window.console) {
        console.error("[omni-embed] failed to load Botpress runtime:", RUNTIME_SRC);
      }
    };
    document.head.appendChild(script);
  }

  installLinkClickCapture();
  loadRuntime();
})();
`;

export const EMBED_BOTS = embedBots.bots;

export const buildBotConfig = bot => ({
  key: bot.key,
  botpressVersion: bot.botpressVersion || EMBED_DEFAULTS.botpressVersion,
  botId: bot.botId,
  clientId: bot.clientId,
  configuration: bot.configuration || {},
  clickWebhook: bot.clickWebhook || "",
});

export const generateEmbedScript = bot => {
  const config = buildBotConfig(bot);
  return LOADER_TEMPLATE.replace(LOADER_TEMPLATE_TOKEN, JSON.stringify(config, null, 2)).replace(
    /\r\n/g,
    "\n",
  );
};

export const embedFileName = bot => `${bot.key}.js`;

export const embedLiveUrl = bot => `https://${EMBED_TARGET.domain}/${bot.key}.js`;

export const templateForDisplay = () => LOADER_TEMPLATE;
